import { FolderItem, Item } from "@/types/fse";
import { useMemo } from "react";
import { usePagination } from "@/views/drive/hooks/use-paginations";
import { useGetFileDetailsQuery } from "@/api/files";
import * as React from "react";
import { UploadStatusMessage, useUploadStatus } from "@/hooks/use-upload-status";
import { TxType } from "@/types/transaction";

export const isFolderItem = (item: Item): item is FolderItem => item.type === "folder";

interface DriveSearchParams {
  folderId?: string | undefined;
  only_shared?: boolean;
}

export const useDriveList = ({ folderId, only_shared }: DriveSearchParams = {}) => {
  const { isLoading, data, error, refetch } = useGetFileDetailsQuery({ fse_id: folderId, only_shared });

  const displayItems = useMemo(
    () => (data && !Array.isArray(data) && isFolderItem(data) ? Object.values(data.items) : []),
    [data],
  );

  const onUploadStatusChange = React.useCallback(
    (event: UploadStatusMessage) => {
      if (
        event.type === "document" &&
        [TxType.UPLOAD, TxType.CHRONOLOGY].includes(event.tx_type) &&
        event.progress >= 1.0
      ) {
        setTimeout(() => {
          refetch();
        }, 3500);
      }
    },
    [refetch],
  );

  useUploadStatus(onUploadStatusChange);

  const pagination = usePagination(displayItems || []);

  return {
    isLoading,
    error,
    ...pagination,
    data,
  };
};
